import React from 'react';
import {useInput} from '../use_input';

export function LoginForm(props) {
  const [username, onUsernameChange] = useInput('', props.onChange);
  const [password, onPasswordChange] = useInput('', props.onChange);

  const onSubmit = (event) => {
    event.preventDefault();
    props.onSubmit(username, password);
  }

  return (
    <form className="login-form" onSubmit={onSubmit}>
      <div className="field">
        <label htmlFor="username">Username</label>
        <input id="username" type="text" name="username" onChange={onUsernameChange} />
      </div>
      <div className="field">
        <label htmlFor="password">Password</label>
        <input id="password" type="password" name="password" onChange={onPasswordChange} />
      </div>
      <div className="submit">
        <input className="btn dark" type="submit" name="submit" value="login" />
      </div>
    </form>
  );
}
